import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Footer from '../Footer';
import GalerijaKlinikeV2 from './GalerijaKlinikeV2';

function Home() {
  return (
    <>
      <HeroSection />
      <GalerijaKlinikeV2 />
      <Footer />
    </>
  );
}

export default Home;